<template>
  <v-row no-gutters justify="center">
    <v-col cols="auto" class="text-center">
      <circle-image-button
        v-if="canDownload && !userIsViewOnly"
        :image="coloredAssetUrls.download"
        title="Download Image With Layers"
        :size="size"
        btnClass="primary"
        @click="$emit('downloadImage')"/>
      <circle-image-button
        v-if="!userIsViewOnly"
        title="Print Image"
        :image="coloredAssetUrls.print"
        :size="size"
        btnClass="primary"
        @click="$emit('printImage')"/>
      <circle-image-button
        v-if="(!ssoEmrPro || enableSavingWithEmrPro) && canAnnotate && !userIsViewOnly"
        title="Save Image With Layers"
        :image="coloredAssetUrls.save"
        :size="size"
        btnClass="primary"
        @click="$emit('saveImage')"/>
      <circle-image-button
        v-if="canAnnotate"
        title="Reset Image"
        :image="coloredAssetUrls.reset"
        :size="size"
        btnClass="primary"
        @click="$emit('resetImage')"/>
      <circle-image-button
        v-if="canAnnotate"
        title="Clear All Annotations"
        :image="coloredAssetUrls.clear"
        :size="size"
        btnClass="primary"
        @click="$emit('clearAnnotations')"/>
    </v-col>
  </v-row>
</template>

<script>
import circleImageButton from "../../controls/CircleImageButton";
import { mapGetters } from "vuex";

export default {
  name: "annotationFileManagementButtonCollection",
  components: { circleImageButton },
  props: {
    context: Object,
    size: { type: String, default: "small" }
  },
  computed: {
    ...mapGetters(["canAnnotate", "canDownload", "ssoEmrPro", "userIsViewOnly", "enableSavingWithEmrPro"])
  }
};
</script>
